module.exports = __webpack_public_path__ + "static/media/school.59ebd82d.png";